import _ from 'underscore';

/**
 * findParentNodeByLevel(map, index)
 * Will return parent node who has children selected with certain level index
 * @param {map} map a site map
 * @param {number} index  level index starting from 0
 * @returns {object} node || undefinded if not found
 */
export function findParentNodeByLevel(map, index) {
  let level = 0;
  let currentNode = _.findWhere(map, { selected: true });
  if (index <= 0) {
    return undefined;
  }

  while (level !== index) {
    if (!currentNode || !currentNode.children) {
      return undefined;
    }

    const selectedChild = _.find(currentNode.children, node => node.selected === true);
    if (selectedChild && level === index - 1) {
      return currentNode;
    }
    currentNode = selectedChild;
    level += 1;
  }

  return undefined;
}
